import bootstrap from 'bootstrap'
import 'mmenu-light'

document.addEventListener('DOMContentLoaded', () => {
  const menu = new MmenuLight(
    document.querySelector('#navbarMenu'),
    "(max-width: 992px)"
  )
  const navigator = menu.navigation({
    theme: "dark"
  })
  const drawer = menu.offcanvas({
    position: "right"
  })
  const toggleButton = document.querySelector('a[href="#navbarMenu"]')
  toggleButton.addEventListener("click", e => {
    e.preventDefault()
    drawer.open()
  })
  const closeButtons = document.querySelectorAll('#navbarMenu a')
  closeButtons.forEach(button => {
    button.addEventListener("click", e => {
      drawer.close()
    })
  })
})